<template>
  <Styled>
    <div class="autocomplete-content">
      <div class="icon-search">
        <span class="icon material-icons"> search </span>
      </div>
      <input
          type="search"
          id="search"
          autocomplete="off"
          :placeholder="placeholder"
          :name="name"
          class="input"
          v-model="search"
          @focus="onFocus"
          @blur="onBlur"
          @keydown="customAction"
      />
      <div :class="`options-container${focus ? ' open' : ''}`">
        <ul
            class="options-ul"
            v-if="
            (focus && Array.isArray(options) && options.length === 0) ||
            isLoading
          ">
          <li class="option-item" v-if="!isLoading">
            <a class="option-link">Digite un nombre o un documento</a>
          </li>
          <li class="option-item" v-if="isLoading">
            <a class="option-link">Cargando...</a>
          </li>
          <li class="option-item"
              v-if="!isLoading && search && search.length === 0">
            <a class="option-link">Escriba para buscar...</a>
          </li>
          <li class="option-item"
              v-if="!isLoading && search && search.length > 0 && options.length === 0">
            <a class="option-link">Sin resultados...</a>
          </li>
        </ul>
        <ul class="options-ul" v-if="!isLoading">
          <li
              class="option-item"
              v-for="(option, index) in options"
              :value="index"
              :key="index">
            <a class="option-link" @click="onClickItem(option)">
              <span class="label user-container ml-1">
                <span class="username">
                  {{ getLabel(option) }}
                </span>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </Styled>
</template>

<script>
import Styled from "./styles";

export default {
  components: {Styled},
  props: ["placeholder", "name", "searchRecords", "label", "value"],
  data: () => ({
    search: "",
    isLoading: false,
    list: [],
    focus: false,
    interval: null,
    options: [],
    item: null
  }),
  mounted() {
    this.search = this.value ? this.value[this.label] : "";
  },
  watch: {
    search() {
      if (!this.search) {
        this.item = null;
        this.$emit("input", null);
        return;
      }
      if (this.search && this.search.length === 0) {
        return;
      }
      this.onSearch();
    },
  },
  methods: {
    customAction(event) {
      const code = event.which || event.keyCode;
      if (code === 27) {
        this.focus = false;
      }
    },
    getLabel(record) {
      return record[this.label];
    },
    onFocus() {
      this.focus = true;
    },
    onBlur() {
      setTimeout(() => {
        this.focus = false;
      }, 200);
    },
    onClickItem(item) {
      this.item = item;
      this.search = item[this.label];
      this.$emit("input", item);
    },
    onFinish(options) {
      this.isLoading = false;
      if (!Array.isArray(options)) {
        return;
      }
      this.options = options;
    },
    onSearch() {
      const search = this.search;
      if (search.length < 2) {
        return;
      }
      if (this.item) {
        return;
      }
      this.isLoading = true;
      if (this.interval) {
        clearTimeout(this.interval);
      }
      this.interval = setTimeout(() => {
        this.searchRecords({
          searchQuery: search,
          callback: options => this.onFinish(options),
        });
      }, 200);
    },
  },
};
</script>
